import React from "react";
import Nav from "./Nav";

function Contact() {
  return (
    <>
      <Nav />
      <div>Contact</div>
    </>
  );
}

export default Contact;
